<dx-data-grid
            #gridArticoli     
            [dataSource]="dataSource"
             [showBorders]="true"
            [focusedRowEnabled]="false"
            [focusedRowIndex]="0"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            [columnResizingMode]="columnResizingMode"
            [showColumnLines]="true"
            [showRowLines]="true"
            [rowAlternationEnabled]="false"
            [allowColumnReordering]="true"
            [wordWrapEnabled]="false">
            
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"  [allowSearch]="false"></dxo-header-filter>
            <dxo-export [enabled]="false"></dxo-export>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

            <dxo-editing
                mode="row"
                [allowAdding]="false"
                [allowUpdating]="false"
                [allowDeleting] ="false"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts> 
            </dxo-editing>

           
<dxi-column
    dataField="data"
    caption="Data"
    format="dd/MM/yyyy"
    dataType="date"
    width="150"
    [sortIndex]="1"
    sortOrder="asc">
</dxi-column>


<dxi-column
    dataField="descrizione">
</dxi-column> 
                        
</dx-data-grid>
